export default "__VITE_ASSET__00f003dd__"